import { RouteHandler } from 'wee-routes';
import $ from 'wee-dom';
import $fetch from 'wee-fetch';

export default new RouteHandler({
    init() {
        $fetch.get('/gcs')
            .then((response) => {
                const tokName = response.data.tok.name;
                const tokValue = response.data.tok.value;
                const $csrfFields = $('input[name="' + tokName + '"]');

                $csrfFields.each((csrfField) => {
                    const $csrfField = $(csrfField);

                    if ($csrfField.length) {
                        $csrfField.val(tokValue);
                    }
                });
            });
    },
});
